import React from "react";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import HeroSection from "../common/HeroSection";
import { HERO_SLIDES } from "../../constants/heroSlides";
import { isRtlLanguage } from "../../utils/i18n";
import "../common/HeroSection.css";
import "./Slider.css";

const SLIDER_SETTINGS = {
  dots: true,
  arrows: true,
  infinite: true,
  fade: true,
  rtl: false,
  speed: 700,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  pauseOnHover: true,
  cssEase: "ease-in-out",
};

function ImageSlider() {
  const { i18n } = useTranslation();
  const pageIsRtl = isRtlLanguage(i18n.language);

  return (
    <div
      className={`hero-slider-ltr ${pageIsRtl ? "hero-slider-ltr--page-rtl" : ""}`}
      dir="ltr"
    >
      <Slider className="hero-slider z-0" {...SLIDER_SETTINGS}>
        {HERO_SLIDES.map((slide) => (
          <HeroSection key={slide.titleKey} {...slide} />
        ))}
      </Slider>
    </div>
  );
}

export default ImageSlider;
